export default {
  title: "explore oracle".toUpperCase(),
}
